import { useRouter } from 'next/router';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { METHODOLOGYGENDER } from '../Methodology.constants';

const MethodologyGender: React.FC = () => {
  const { locale } = useRouter();

  const methodologyGender = METHODOLOGYGENDER(locale);

  return (
    <div>
      <StyledRecharts className="methodology gender">
        <PieChart width={400} height={400}>
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            iconType="square"
            width={120}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            labelStyle={{ display: 'none' }}
            separator=": "
            formatter={(value: number) => value.toFixed(1) + '%'}
            wrapperClassName="tooltip-y"
          />
          <Pie data={methodologyGender} dataKey="value" cx="50%" cy="28%">
            <Cell fill="#746FB3" />
            <Cell fill="#1B9D76" />
          </Pie>
        </PieChart>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyGender;
